import http from '../utils/http';

const reportFormApi = {
    /**
     * 近7天终端在线离线数量
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#247
     */
    sevenDeviceLineInfo() {
        return http.post('/reportForms/sevenDeviceLineInfo')
    },

    /**
     * 近7天单个终端节目下载趋势
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#242
     */
    getProgramDownloadNum() {
        return http.post('/reportForms/getProgramDownloadNum')
    },

    /**
     * 根据deviceCode查询终端上线日志
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#243
     *
     * @param {Object} options
     */
    getOnLineInfo(options) {
        return http.post('/reportForms/getOnLineInfo', options)
    },

    /**
     * 报表统计-播放日志-每日
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#244
     *
     * @param {Object} options
     */
    reportLogDay(options) {
        return http.post('/reportForms/reportLogDay', options)
    },

    /**
     * 报表统计-播放日志-每月
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#245
     *
     * @param {Object} options
     */
    reportLogMonth(options) {
        return http.post('/reportForms/reportLogMonth', options)
    },

    /**
     * 报表统计-播放日志-时间段
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#246
     *
     * @param {Object} options
     */
    reportLogTimeFrame(options) {
        return http.post('/reportForms/reportLogTimeFrame', options)
    },

    /**
     * 报表统计-播放日志-导出报表
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#269
     *
     * @param {Object} options
     */
    reportLogTimeFrameExcel(options) {
        return http.post('/reportForms/reportLogTimeFrameExcel', options)
    },

}

export default reportFormApi;
